<template>
  <transition name="modal">
    <div class="modal-mask"  @click="handleClose">
      <div class="modal-wrapper">
        <div v-if="modalData.component" class='modal-if'>
          <component :is="modalData.component" :modalData="modalData" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Modal from '@/shared/constants/modal';

import Warning from '@/shared/components/modals/Warning.vue';
import Error from '@/shared/components/modals/Error.vue';

import AlreadyHasActiveReportOfSickness from '@/views/components/modals/AlreadyHasActiveReportOfSickness.vue';
import InfoSafetyNetModal from '@/views/components/modals/InfoSafetyNetModal.vue';
import EmployeeSummaryPersonalEdit from '@/views/components/modals/EmployeeSummaryPersonalEdit.vue';
import EmployeeEmploymentRelationshipDetailsHistory from '@/views/components/modals/EmployeeEmploymentRelationshipDetailsHistory.vue';
import FirstOfAbsenceDuringOrBeforeExistingReportOfSickness from '@/views/components/modals/FirstOfAbsenceDuringOrBeforeExistingReportOfSickness.vue';

// confirmation normal delete of report of sickness entities
import DeleteRecoveryConfirmation from '@/views/components/modals/DeleteRecoveryConfirmation.vue';
import DeleteReportOfSicknessConfirmation from '@/views/components/modals/DeleteReportOfSicknessConfirmation.vue';

import DeletePeriodConfirmation from '@/views/components/modals/DeletePeriodConfirmation.vue';
import DeleteProcessedPeriodConfirmation from '@/views/components/modals/DeleteProcessedPeriodConfirmation.vue';
import EditProcessedPeriodConfirmation from '@/views/components/modals/EditProcessedPeriodConfirmation.vue';

// confirmation processed report of sickness entities
import DeleteProcessedRecoveryConfirmation from '@/views/components/modals/DeleteProcessedRecoveryConfirmation.vue';
import EditProcessedRecoveryConfirmation from '@/views/components/modals/EditProcessedRecoveryConfirmation.vue';

import DeleteProcessedReportOfSicknessConfirmation from '@/views/components/modals/DeleteProcessedReportOfSicknessConfirmation.vue';
import EditProcessedReportOfSicknessConfirmation from '@/views/components/modals/EditProcessedReportOfSicknessConfirmation.vue';

import StartDateBeforeIndemnityProcessedPickedForPeriod from '@/views/components/modals/StartDateBeforeIndemnityProcessedPickedForPeriod.vue';
import StartDateBeforeIndemnityProcessedPickedForRecovery from '@/views/components/modals/StartDateBeforeIndemnityProcessedPickedForRecovery.vue';

import LogoutConfirmation from '@/views/components/modals/LogoutConfirmation.vue';

export default {
  name: 'Modal',
  props: {
    modalData: null
  },
  components: {
    Warning,
    Error,

    AlreadyHasActiveReportOfSickness,
    InfoSafetyNetModal,
    EmployeeSummaryPersonalEdit,
    EmployeeEmploymentRelationshipDetailsHistory,
    FirstOfAbsenceDuringOrBeforeExistingReportOfSickness,

    DeleteRecoveryConfirmation,
    EditProcessedRecoveryConfirmation,
    DeleteProcessedRecoveryConfirmation,

    DeletePeriodConfirmation,
    EditProcessedPeriodConfirmation,
    DeleteProcessedPeriodConfirmation,

    DeleteReportOfSicknessConfirmation,
    EditProcessedReportOfSicknessConfirmation,
    DeleteProcessedReportOfSicknessConfirmation,

    StartDateBeforeIndemnityProcessedPickedForPeriod,
    StartDateBeforeIndemnityProcessedPickedForRecovery,
    LogoutConfirmation
  },
  methods: {
    handleClose (e) {
      if (e.target.className === 'modal-if' || e.target.className === 'modal-wrapper') {
        this.$store.dispatch(Modal.Actions.CLOSE);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(24, 37, 50, 0.5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;

  margin: 0px auto;
  background-color: #fff;
  border-radius: $border-radius;
  box-shadow: 0 3px 20px rgba(0, 0, 20, .33);
  transition: all .3s ease;
  overflow: hidden;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1);
  transform: scale(1);
}

</style>
